<template>
  <div class="space-y-8">
    <slot name="header" />
    <slot name="table" />
  </div>
</template>
